/**
 * Configuración de la aplicación
 */
export const CONFIG = {
  // Configuración de Google OAuth
  google: {
    // IMPORTANTE: Reemplazar con tu Client ID de Google Console
    clientId: '737668488692-opo6imnl80s9hk3qkafavfbh4vjcq787.apps.googleusercontent.com',
    scopes: [
      'https://www.googleapis.com/auth/calendar.readonly',
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile'
    ],
    discoveryDocs: [
      'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'
    ]
  },

  // Configuración del propietario del calendario
  owner: {
    // Email del propietario del calendario (tu email)
    email: 'luis.rioja11@gmail.com',
    // Lista de emails autorizados para acceder (incluyendo el tuyo)
    whitelist: [
      'luis.rioja11@gmail.com',
      'mariademm24@gmail.com',
      'luiser.gamer999@gmail.com'
      // Agrega más emails según necesites
    ]
  },

  // Configuración del calendario
  calendar: {
    // Hora de inicio del calendario (formato 24h)
    startHour: 6,
    // Hora de fin del calendario (formato 24h)
    endHour: 23,
    // Formato de hora (12h o 24h)
    timeFormat: '24h' as const,
    // Primer día de la semana (0 = domingo, 1 = lunes)
    firstDayOfWeek: 1,
    // Número máximo de eventos a cargar por petición
    maxEventsPerRequest: 250
  },

  // Configuración de la UI
  ui: {
    // Idioma de la aplicación
    locale: 'es-ES',
    // Tema por defecto
    theme: 'light' as const,
    // Animaciones habilitadas
    animationsEnabled: true,
    // Mostrar fines de semana
    showWeekends: true
  },

  // Configuración de almacenamiento
  storage: {
    // Prefijo para las claves de localStorage
    prefix: 'calendar-checker-',
    // Tiempo de expiración de la caché (en minutos)
    cacheExpiration: 60
  },

  // URLs de la aplicación
  urls: {
    // URL base de la API de Google
    googleApiBase: 'https://www.googleapis.com/calendar/v3',
    // URL de la documentación
    docsUrl: 'https://github.com/tu-usuario/calendar-checker',
    // URL de soporte
    supportUrl: 'mailto:tu-email@dominio.com'
  },

  // Configuración de desarrollo
  development: {
    // Modo debug
    debugMode: process.env.NODE_ENV === 'development',
    // Logs habilitados
    logsEnabled: process.env.NODE_ENV === 'development',
    // Mock data para desarrollo
    useMockData: false
  }
};

/**
 * Tipo para la configuración
 */
export type AppConfig = typeof CONFIG;

/**
 * Configuración específica del entorno
 */
export const getEnvironmentConfig = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return {
    development: {
      debugMode: isDevelopment,
      logsEnabled: isDevelopment,
      useMockData: false
    }
  };
};

/**
 * Obtiene la configuración completa con valores del entorno
 */
export const getConfig = (): AppConfig => {
  const envConfig = getEnvironmentConfig();
  return { ...CONFIG, ...envConfig };
};
